export default __webpack_public_path__ + "static/media/currency.2bbb2d1f.jpg";